<template>
  <div class="width1460">
    <div class="base-head flex justify-between item-center">
      <div class="flex">
        <div class="logo flex item-center">
          <img
            src="@/assets/image/logo.png"
            alt=""
            width="36"
          />
          <p>大贤集团</p>
        </div>
        <div class="nav flex item-center">
          <div
            v-for="(item,index) in navList"
            :key="index"
            class="nav-item"
            :class="{on:item.link === $route.path}"
            @click="navClick(item.link)"
          >
            <a href="javascript:void(0)">{{ item.name }}</a>
          </div>
        </div>
      </div>
      <div class="pic">
        <img
          src="~@/assets/image/logo1.png"
          alt=""
          width="309"
        />
      </div>
    </div>
  </div>
</template>



<script>
export default {
  name: "BaseHeader",
  data(){
    return {
      navList:[
        {
          name:'首页',
          link:'/'
        },
        {
          name:'企业简介',
          link:'/companyProfile'
        },
        {
          name:'企业文化',
          link:'/corporateCulture'
        },
        {
          name:'发展历程',
          link:'/history'
        },
        {
          name:'产业板块',
          link:'/industry'
        },
        {
          name:'联系我们',
          link:'/contactUs'
        }
      ]
    }
  },
  created() {
    // console.log(this.$route)
  },
  methods:{
    navClick(link){
      this.$router.push({ path: link });
    }
  }
}
</script>



<style scoped lang="less">
.base-head{
  height: 90px;
  .logo{
    color: #55131D;
    font-weight: bold;
    font-size: 46px;
    p{
      margin-left: 18px;
    }
  }
  .nav{
    margin-left: 66px;
    font-size: 18px;
    font-weight: 400;
    .nav-item{
      margin-right: 56px;
      position: relative;
      &.on:after{
        position: absolute;
        bottom: -10px;
        left: 50%;
        content: ' ';
        width: 100%;
        height: 4px;
        background: #55131D;
        border-radius: 10px 10px 10px 10px;
        transform: translateX(-50%);
      }
    }
  }
}
</style>
